import { Button, Heading } from "@components/theming";
import useDomainBasedTranslations from "@utils/useDomainBasedTranslations";

export default function EventTicketButton({
  showEventDescription,
  onClick,
  href,
  priceText,
}: {
  showEventDescription?: boolean;
  onClick: React.MouseEventHandler<HTMLButtonElement | HTMLAnchorElement>;
  href?: string;
  priceText?: string;
}) {
  const t = useDomainBasedTranslations("EventPage");

  return (
    <>
      <Button
        href={href || undefined}
        onClick={onClick}
        whitelabelVariant="solid"
        size="3"
        whitelabelClasses="w-full md:mt-4"
        shopsiteClasses="w-full md:w-2/3"
      >
        {showEventDescription ? t("gettickets") : t("showdetails")}
      </Button>
      {priceText && (
        <Heading
          as="h2"
          shopsiteClasses="md:w-1/3 text-gray-500 text-base leading-7"
        >
          {priceText}
        </Heading>
      )}
    </>
  );
}
